import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BuildingStatus } from '../land/state'
import { initialCastle1State, Castle1State } from './state'

export const castle1Slice = createSlice({
  name: 'castle1',
  initialState: initialCastle1State as Castle1State,
  reducers: {
    setCastle1Loading: (state: Castle1State, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setCastle1ImmediateLoading: (state: Castle1State, action: PayloadAction<boolean>) => {
      state.isImmediate = action.payload
    },
    setCastle1Error: (state: Castle1State, action: PayloadAction<string | undefined>) => {
      state.error = action.payload
    },
    setCastle1BuildingStatus: (state: Castle1State, action: PayloadAction<Partial<BuildingStatus>>) => {
      const existingStatus = state.buildingStatus || initialCastle1State.buildingStatus
      const payload = action.payload
      
      const mergedStatus = { ...existingStatus } as Partial<BuildingStatus>
      
      for (const key in payload) {
        if (payload[key as keyof BuildingStatus]) {
          const existingBuilding = existingStatus[key as keyof BuildingStatus]
          const payloadBuilding = payload[key as keyof BuildingStatus]
          if (existingBuilding) {
            mergedStatus[key as keyof BuildingStatus] = {
              ...existingBuilding,
              ...payloadBuilding,
              hp: Number(payloadBuilding?.hp ?? 0),
              maxHp: Number(payloadBuilding?.maxHp ?? 0),
            } as any
          } else {
            mergedStatus[key as keyof BuildingStatus] = {
              ...payloadBuilding,
              hp: Number(payloadBuilding?.hp ?? 0),
              maxHp: Number(payloadBuilding?.maxHp ?? 0),
            } as any
          }
        }
      }
      
      state.buildingStatus = mergedStatus
    },
    setCastle1RepairRequirements: (state: Castle1State, action: PayloadAction<{ ecsToken: number; gem: number; stone: number; wood: number }>) => {
      state.repairRequirements = action.payload
    },
    setCastle1RestoreBuilding: (state: Castle1State) => {
      state.isRestored = true
    },
    setCastle1FetchSupportCharacters: (state: Castle1State, action: PayloadAction<any[]>) => {
      state.supportCharacters = action.payload
    },
    setCastle1SupportCharacters: (state: Castle1State, action: PayloadAction<any[]>) => {
      state.supportCharacters = [...state.supportCharacters, ...action.payload]
      state.isSetSupportCharacterSuccess = true
    },
    setCastle1ClearStatus: (state: Castle1State) => {
      state.isSetSupportCharacterSuccess = false
      state.error = undefined
    },
    setCastle1SupportState: (state: Castle1State, action: PayloadAction<boolean>) => {
      state.supportState = action.payload
    },
    setCastle1UpgradeBuilding: (state: Castle1State) => {
      state.upgradeAvailable = false
    },
    setCastle1UpgradeRequirements: (state: Castle1State, action: PayloadAction<{ ecsToken: number }>) => {
      state.upgradeRequirements = action.payload
    },
    setCastle1UpgradeAvailable: (state: Castle1State, action: PayloadAction<boolean>) => {
      state.upgradeAvailable = action.payload
    },
    setCastle1RemoveCharacterFromBuilding: (state: Castle1State, action: PayloadAction<{ success: boolean; building: string; character: string }>) => {
      // Handle character removal if needed
    },
    setCastle1AddCharacterToBuilding: (state: Castle1State, action: PayloadAction<{ success: boolean; building: string; character: string }>) => {
      // Handle character addition if needed
    },
    setCastle1AllMiningStatus: (state: Castle1State, action: PayloadAction<any>) => {
      state.allMiningStatus = action.payload
    },
  },
})

export const {
  setCastle1Loading,
  setCastle1ImmediateLoading,
  setCastle1Error,
  setCastle1BuildingStatus,
  setCastle1RepairRequirements,
  setCastle1RestoreBuilding,
  setCastle1FetchSupportCharacters,
  setCastle1SupportCharacters,
  setCastle1ClearStatus,
  setCastle1SupportState,
  setCastle1UpgradeBuilding,
  setCastle1UpgradeRequirements,
  setCastle1UpgradeAvailable,
  setCastle1RemoveCharacterFromBuilding,
  setCastle1AddCharacterToBuilding,
  setCastle1AllMiningStatus,
} = castle1Slice.actions

export default castle1Slice.reducer

